import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-outlined-icon_951fad8126bf70a274b5138c86c1fda1",
  "use": "calendar-outlined-icon_951fad8126bf70a274b5138c86c1fda1-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"calendar-outlined-icon_951fad8126bf70a274b5138c86c1fda1\">\n<path d=\"M9.5 1.5H9V0.5H8V1.5H4V0.5H3V1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.945 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V2.5C10.5 1.95 10.05 1.5 9.5 1.5ZM9.5 9.5H2.5V4.5H9.5V9.5ZM9.5 3.5H2.5V2.5H9.5V3.5Z\" fill=\"#7387FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol